import { render, staticRenderFns } from "./AddVisitPerson.vue?vue&type=template&id=2868a67e&scoped=true&"
import script from "./AddVisitPerson.vue?vue&type=script&lang=js&"
export * from "./AddVisitPerson.vue?vue&type=script&lang=js&"
import style0 from "./AddVisitPerson.vue?vue&type=style&index=0&id=2868a67e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2868a67e",
  null
  
)

export default component.exports